/** Greaves and padding. Cheap protection for the location a rifle finds least. */

import type { EquipmentSlot } from '@/sim/inventory/slotContract';

export const LEGS_SLOT = {
  id: 'legs',
  label: 'Legs',
  description: 'Greaves and padding. Cheap protection for the location a rifle finds least.',
} as const satisfies EquipmentSlot;
